import { ReactNode } from 'react'

interface ReviewItemsProps {
  label: ReactNode
  icon: string
  centered?: boolean
}

const ReviewItems = ({ label, icon, centered = false }: ReviewItemsProps) => {
  return (
    <div className={`review-item ${centered ? 'centered' : ''}`}>
      <div className="box">
        <i className={`fa-light fa-${icon}`} />
        <span>{label}</span>
      </div>
    </div>
  )
}

export default ReviewItems
